import PropertyInfiniteScrollContainer from "../../../components/property/other/PropertyInfiniteScroll";

const PropertyInfiniteScroll = () => {
  return <PropertyInfiniteScrollContainer />;
};

export default PropertyInfiniteScroll;
